import { Component, EventEmitter, Input, Output } from "@angular/core";
import { StateService, UIRouterGlobals } from "@uirouter/core";

@Component({
  selector: "ab-time-dur-switch",
  templateUrl: "./time-dur-switch.component.html",
})
export class TimeDurSwitchComponent {
  @Input() public dur: string;
  @Input() public lastN: number;
  @Input() public enabled: boolean;
  @Output() public changed = new EventEmitter<any>();

  constructor(
    private $state: StateService,
    private $uiRouterGlobals: UIRouterGlobals,
  ) {}

  public changeDur(params: any) {
    this.changed.emit(params);
    this.$state.go(this.$uiRouterGlobals.current, params);
  }
}
